/* eslint-disable react/react-in-jsx-scope */
import { getAgencies, removeAgency, addAgency, updateAgency } from "../services/agencies";
import DataTable from "../components/Table/DataTable";
import { roles } from "../utils/roles";
import { AgencyVisual } from "../components/Table/Visual";

const headCells = [
  {
    field: "name",
    headerName: "Name",
    sortable: true,
    editable: false,
    isOnTable: true,
    isOnFilter: true,
    type: "textField",
    flex: 1,
    filterable: false,
    isRequired: true,
    helperText: "Please provide a name.",
    renderCell: (params) => {
      const agencyName = params.row.name;
      const agencyVisual = params.row.imgPath;
      return <AgencyVisual name={agencyName} visual={agencyVisual ? `${process.env.REACT_APP_PROXY}/assets/agencies/${agencyVisual}` : null} />;
    },
  },
];

const entity = {
  tableId: "agencies",
  label: "agency",
};

const permissions = {
  read: [roles.ALL],
  delete: [roles.SUPERADMIN],
  create: [roles.SUPERADMIN],
  update: [roles.SUPERADMIN],
};

export default function AgenciesPages() {
  return <DataTable permissions={permissions} entity={entity} fetchData={getAgencies} addData={addAgency} deleteData={removeAgency} updateData={updateAgency} headCells={headCells} />;
}
